

// PRD local
export const urlEndPoint: string = 'https://observatorio.ceplan.gob.pe';
export const urlEndPointGeo: string = 'https://geo.ceplan.gob.pe';

// QA local
//export const urlEndPoint: string = 'http://test-observatorio.ceplan.gob.pe:4000';
//export const urlEndPointGeo: string = 'https://geo.ceplan.gob.pe';

// DEV local
//export const urlEndPoint: string = 'http://127.0.0.1:4000';
//export const urlEndPointGeo: string = 'http://127.0.0.1:3000';

// DEV API
export const urlAPI: string = '/api/v1';


export const urlCol: string = `${urlAPI}/obs/col`;
export const urlData: string = `${urlAPI}/obs/data`;
export const urlEvt: string = `${urlAPI}/obs/evt`;
export const urlFco: string = `${urlAPI}/obs/fconf`;
export const urlGr: string = `${urlAPI}/obs/gr`;
export const urlGrt: string = `${urlAPI}/obs/grt`;
export const urlRow: string = `${urlAPI}/obs/row`;
export const urlT1: string = `${urlAPI}/obs/t1`;
export const urlTem: string = `${urlAPI}/obs/tem`;
export const urlT3: string = `${urlAPI}/obs/t3`;
export const urlT3Rel: string = `${urlAPI}/obs/t3rel`;
export const urlSec: string = `${urlAPI}/obs/sec`;
export const urlPodc: string = `${urlAPI}/obs/podc`;
export const urlSub: string = `${urlAPI}/obs/sub`;
export const urlBbl: string = `${urlAPI}/obs/bbl`;
export const urlSect: string = `${urlAPI}/obs/sect`;
export const urlLks: string = `${urlAPI}/obs/lks`;
export const urlDpto: string = `${urlAPI}/obs/dpto`;
export const urlLkd: string = `${urlAPI}/obs/lkd`;
export const urlNew: string = `${urlAPI}/obs/news`;
export const urlCNew: string = `${urlAPI}/obs/cnews`;
export const urlPrim: string = `${urlAPI}/obs/prim`;
export const urlRep: string = `${urlAPI}/obs/rep`;
export const urlPubC: string = `${urlAPI}/obs/pubc`;
export const urlPubT: string = `${urlAPI}/obs/pubt`;
export const urlPubl: string = `${urlAPI}/obs/publ`;
export const urlClassif: string = `${urlAPI}/obs/classif`;
export const urlLogin: string = `${urlAPI}/auth`;
export const urlUpload: string = `${urlAPI}/subir`;
export const urlPeriod: string = `${urlAPI}/obs/period`;
export const urlQuad: string = `${urlAPI}/obs/quad`;
export const urlScatterPeriod: string = `${urlAPI}/obs/speriod`;
export const urlScatterPoint: string = `${urlAPI}/obs/spoints`;
export const urlMtRel: string = `${urlAPI}/obs/mtrel`;
export const urlSubs: string = `${urlAPI}/obs/subs`;
export const urlT3Sector: string = `${urlAPI}/obs/t3sector`;

export const urlAnsw: string = `${urlAPI}/sv/answer`;
export const urlAx: string = `${urlAPI}/sv/axis`;
export const urlUsr: string = `${urlAPI}/users`;
export const urlLog: string = `${urlAPI}/logs`;
export const urlCmt: string = `${urlAPI}/comment`;
export const urlAcs: string = `${urlAPI}/access`;
export const urlRl: string = `${urlAPI}/role`;
export const urlUr: string = `${urlAPI}/urole`;
export const urlPer: string = `${urlAPI}/persons`;
export const urlSt: string = `${urlAPI}/sv/status`;
export const urlSv: string = `${urlAPI}/sv/survey`;
export const urlSvSec: string = `${urlAPI}/sv/svsection`;
export const urlTm: string = `${urlAPI}/sv/team`;
export const urlUt: string = `${urlAPI}/sv/uteam`;
export const urlQs: string = `${urlAPI}/sv/qs`;
export const urlLinkQ: string = `${urlAPI}/sv/linkq`;
export const urlSecV: string = `${urlAPI}/sv/sec`;
export const urlQt: string = `${urlAPI}/sv/qstype`;
export const urlOp: string = `${urlAPI}/sv/opts`;
export const urlPrm: string = `${urlAPI}/sv/prmiss`;
export const urlTracking: string = `${urlAPI}/sv/tracking`; //Agregado para tracking survey
export const urlPodcasts: string = `${urlAPI}/obs/podcast`; //Agregado para podcasts
export const urlPodGroup: string = `${urlAPI}/obs/podcastgroup`; //Agregado para podcastsGroup
export const urlForos: string = `${urlAPI}/obs/forosdelfuturo`; //Agregado para foros
export const urlRedes: string = `${urlAPI}/obs/redes`; //Agregado para redes
export const urlDocDpto: string = `${urlAPI}/obs/docdpto`; //Agregado para adm doc territoriales
export const urlDocSector: string = `${urlAPI}/obs/docsector`; //Agregado para adm doc sectoriales
export const urlCompendio:string= `${urlAPI}/obs/compendio`; //Agregado para compendio
export const urlT3Record:string= `${urlAPI}/obs/t3record`; //Agregado para historial de versiones de fichas
